import React from "react";
import AccountBlockedImg from "./img/account-blocked.svg";
import { useTranslation } from "react-i18next";

const AccountBlocked: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="d-flex align-items-center justify-content-start bg-main-background min-vh-100 px-3 py-4 flex-column">
      <div
        className="rounded bg-white px-3 py-5 w-100 text-center"
        style={{ maxWidth: "636px" }}
      >
        <div className="row py-5">
          <div className="col-12 col-sm-8 m-auto">
            <img src={AccountBlockedImg} alt="Account Blocked" className="img-fluid" />
            <p className="text-dark-gray fs-2 fw-bold mt-4 mb-1">{t("accountBlocked.title")}</p>
            <p className="text-background-mobile px-2">{t("accountBlocked.description")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AccountBlocked;
